import { jsonToQueryString } from '@vezeeta/web-utils';
import configurations from '../views/payment/Config';

const fetchCmsContent = (brandKey, contentType, lang) => {
  const contentQuery = {
    brandKey,
    contentType,
    lang,
  };
  console.log(`${configurations.patientsWebCMS.retrieveCmsContent}`);
  return fetch(`${configurations.patientsWebCMS.retrieveCmsContent}?${jsonToQueryString(contentQuery)}`);
};

export default fetchCmsContent;



// WEBPACK FOOTER //
// ./src/api/cms.js